import React from 'react';

import SimpleContainer from '../../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../../containers/categorycontainer/CategoryContainer';

import backgroundImage from '../../media/help-and-guides/air-pollution-and-the-curse.jpg';

import 'bootstrap/dist/css/bootstrap.css';

import { PageText, Categories } from '../../input-text/en/help-and-guides/air-pollution-and-the-curse_page';

class AirPollutionAndTheCurse extends React.Component {

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container' backgroundImage={backgroundImage}>
          <div className='col-sm-offset-4 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p dangerouslySetInnerHTML={{ __html: PageText._2 }} ></p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } />
      </div>
    );
  }
};

export default AirPollutionAndTheCurse;



// WEBPACK FOOTER //
// ./src/routes/help-and-guides/AirPollutionAndTheCurse.js